import React, { FC, useState } from "react";
import {
  Divider,
  Grid,
  Typography,
  Box,
  Snackbar,
  Alert,
  Select,
  MenuItem,
  SelectChangeEvent,
  IconButton,
} from "@mui/material";
import BorderColorTwoToneIcon from "@mui/icons-material/BorderColorTwoTone";
import { IDocument } from "../../interface/IDocument";
import { DeletePostModal } from "./modal-delete";

interface Props {
  patientId: string;
  documentation: IDocument[];
  onSelectDocumentation: (selectedDocumentation: string) => void;
  handleDelete: (id: string) => void;
}

export const DetailDocumentation: FC<Props> = ({
  documentation,
  onSelectDocumentation,
  handleDelete,
}) => {
  const [selectedValue, setSelectedValue] = useState<
    string | "Dokumentation Filtern"
  >("Dokumentation Filtern");
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const dateFormat = (dateAt: string) => {
    const date = new Date(dateAt);
    const hour = date.toLocaleTimeString();
    const dateFormatted = date.toLocaleDateString();
    return { hour, dateFormatted };
  };

  const handleSelectChange = (event: SelectChangeEvent<string>) => {
    setSelectedValue(event.target.value);
  };

  const menuItems = [
    {
      label: "Dokumentation Filtern",
      value: "Dokumentation Filtern",
    },
    {
      label: "Allgemein",
      value: "allgemein",
    },
    {
      label: "Wichtig",
      value: "wichtig",
    },
    {
      label: "Psy. Gutachten",
      value: "psy-gutachten",
    },
    {
      label: "Ernährungstherapie",
      value: "ernährungstherapie",
    },
    {
      label: "Verhaltenstraining",
      value: "verhaltenstraining",
    },
    {
      label: "Sporttherapie",
      value: "sporttherapie",
    },
  ];

  const filterDocumentation =
    selectedValue === "Dokumentation Filtern"
      ? documentation
      : documentation.filter((doc) => doc.category[0] === selectedValue);

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <Grid container mt={15}>
      {documentation && documentation.length > 0 && (
        <Grid item xs={12} sm={12}>
          <Grid item sm={8} container justifyContent="space-between">
            <Typography variant="h5" component="h5" fontWeight={700}>
              Dokumentation
            </Typography>
            <Grid item xs={12} sm={3}>
              <Select
                labelId="select-label"
                id="select"
                value={selectedValue}
                onChange={handleSelectChange}
                variant="outlined"
                fullWidth
              >
                {menuItems.map((item, index) => (
                  <MenuItem key={index} value={item.value}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={8}>
            <Divider sx={{ marginTop: "20px" }} />
          </Grid>

          {filterDocumentation.length > 0 ? (
            filterDocumentation.map((item, index) => (
              <Grid container spacing={2} mt={3} mb={2} key={index}>
                <Grid item xs={12} sm={8}>
                  <Grid container spacing={2} mb={2}>
                    <Grid
                      item
                      xs={11}
                      sm={4}
                      sx={{
                        borderLeft:
                          item.category && item.category[0] === "wichtig"
                            ? "2px solid red"
                            : "none",
                        marginLeft: "5px",
                      }}
                    >
                      <Typography fontWeight={600}>
                        Erstellt: {dateFormat(item.updatedAt).dateFormatted}
                      </Typography>
                      <Typography fontWeight={600}>
                        Stunde: {dateFormat(item?.updatedAt).hour}
                      </Typography>

                      <Typography>
                        {item.employee?.firstName || item.title} {""}{" "}
                        {item.employee?.lastName}
                      </Typography>
                      <Typography>{item?.category}</Typography>
                    </Grid>

                    <Grid item xs={12} sm={7.91}>
                      <Typography
                        component="div"
                        sx={{ whiteSpace: "pre-wrap" }}
                      >
                        {item?.description}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid container>
                    <Grid item xs={12} sm={12}>
                      <Box display="flex" justifyContent="end">
                        <IconButton
                          type="submit"
                          color="primary"
                          size="small"
                          sx={{
                            marginTop: "10px",
                            padding: "10px",
                            marginRight: "10px",
                          }}
                          onClick={() => onSelectDocumentation(item._id || "")}
                        >
                          <BorderColorTwoToneIcon fontSize="small" />
                        </IconButton>

                        <DeletePostModal
                          onDelete={() => {
                            handleDelete(item._id);
                            setSnackbarOpen(true);
                          }}
                        />
                      </Box>
                    </Grid>
                  </Grid>
                  <Snackbar
                    open={snackbarOpen}
                    autoHideDuration={3000}
                    onClose={handleSnackbarClose}
                  >
                    <Alert
                      severity="success"
                      variant="filled"
                      onClose={handleSnackbarClose}
                    >
                      Dokumentation erfolgreich gelöscht
                    </Alert>
                  </Snackbar>

                  <Divider
                    sx={{ borderTop: "1px solid black", marginTop: "10px" }}
                  />
                </Grid>
              </Grid>
            ))
          ) : (
            <Grid item xs={12} sm={12}>
              <Typography variant="body1" mt={15} mb={15} textAlign={"center"}>
                Es gibt keine Dokumente zum Anzeigen
              </Typography>
            </Grid>
          )}
        </Grid>
      )}
    </Grid>
  );
};
